import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/quiz/RealFake.css";

const ChallengePage = () => {
  const navigate = useNavigate(); // Hook to programmatically navigate between routes

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--primary-bg", "#ebebe1");
    root.style.setProperty("--box-bg", "#3e5e48");
    root.style.setProperty("--accent-yellow", "#fbc640");
    root.style.setProperty("--main-green", "#2f472c");
  }, []);

  return (
    <div className="challenge-container text-center">
      <h1 className="challenge-title">Enhance Your Digital Citizenship Skills</h1>
      <p className="challenge-subtitle">
        Learn to navigate the digital information landscape with confidence
      </p>

      <div className="row justify-content-center">
        {/* Box 1 */}
        <div className="col-md-5 m-3 challenge-box">
          <div className="box-inner">
            <img src="/icons/quiz.png" alt="Quiz Icon" className="quiz-icon" />
            <h3 className="challenge-heading">Fact-Checking Challenge</h3>
            <p className="challenge-desc">
              Test your ability to identify true and false political claims with our fact-checking quiz.
            </p>
            <button className="start-button" onClick={() => navigate("/quiz")}>
              START QUIZ
            </button>
          </div>
        </div>

        {/* Box 2 */}
        <div className="col-md-5 m-3 challenge-box">
          <div className="box-inner">
            <img src="/icons/scenario.png" alt="Scenario Icon" className="quiz-icon" />
            <h3 className="challenge-heading">Real-World Scenarios</h3>
            <p className="challenge-desc">
              Experience realistic situations and learn how your choices influence the spread of misinformation.
            </p>
            <button className="start-button" onClick={() => navigate("/scenario")}>
              START SCENARIO
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengePage;

